export type RuntimeUrlEnvironment = Partial<
    Record<'VITE_SOCKET_URL' | 'VITE_API_URL' | 'VITE_API_BASE_URL', string>
>;

const LOCAL_BACKEND_URL = 'http://localhost:3001';

export const resolveApiBaseUrl = (env: RuntimeUrlEnvironment): string =>
    env.VITE_API_URL || env.VITE_API_BASE_URL || LOCAL_BACKEND_URL;

export const resolveSocketUrl = (
    env: RuntimeUrlEnvironment,
    currentOrigin = LOCAL_BACKEND_URL,
): string => {
    if (env.VITE_SOCKET_URL) return env.VITE_SOCKET_URL;
    try {
        return new URL(resolveApiBaseUrl(env), currentOrigin).origin;
    } catch {
        return currentOrigin;
    }
};
